/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_ConfirmSlotRequest } from '../models/Routemize_DTOs_ConfirmSlotRequest';
import type { Routemize_DTOs_ConfirmSlotResponse } from '../models/Routemize_DTOs_ConfirmSlotResponse';
import type { Routemize_DTOs_HoldSlotRequest } from '../models/Routemize_DTOs_HoldSlotRequest';
import type { Routemize_DTOs_HoldSlotResponse } from '../models/Routemize_DTOs_HoldSlotResponse';
import type { Routemize_DTOs_ReleaseSlotRequest } from '../models/Routemize_DTOs_ReleaseSlotRequest';
import type { Routemize_DTOs_ReleaseSlotResponse } from '../models/Routemize_DTOs_ReleaseSlotResponse';
import type { Routemize_DTOs_SchedulingResponse } from '../models/Routemize_DTOs_SchedulingResponse';
import type { Routemize_DTOs_SlotAvailabilityResponse } from '../models/Routemize_DTOs_SlotAvailabilityResponse';
import type { Routemize_DTOs_SlotSuggestionDTO } from '../models/Routemize_DTOs_SlotSuggestionDTO';
import type { Routemize_Entities_AuditTrailEntry } from '../models/Routemize_Entities_AuditTrailEntry';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RoutemizationService {
    /**
     * @param entityId
     * @param entityType
     * @returns Routemize_Entities_AuditTrailEntry OK
     * @throws ApiError
     */
    public static getApiAppRoutemizationGetAuditTrail(
        entityId: string,
        entityType?: string,
    ): CancelablePromise<Array<Routemize_Entities_AuditTrailEntry>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/routemization/getAuditTrail/{entityId}',
            path: {
                'entityId': entityId,
            },
            query: {
                'entityType': entityType,
            },
        });
    }
    /**
     * @param requestId
     * @returns Routemize_DTOs_SlotSuggestionDTO OK
     * @throws ApiError
     */
    public static getApiAppRoutemizationGetSlots(
        requestId: string,
    ): CancelablePromise<Array<Routemize_DTOs_SlotSuggestionDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/routemization/getSlots/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
    /**
     * @param requestId
     * @param bypassServiceArea
     * @returns Routemize_DTOs_SchedulingResponse OK
     * @throws ApiError
     */
    public static getApiAppRoutemizationGetSlotsWithResponse(
        requestId: string,
        bypassServiceArea: boolean = false,
    ): CancelablePromise<Routemize_DTOs_SchedulingResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/routemization/getSlotsWithResponse/{requestId}',
            path: {
                'requestId': requestId,
            },
            query: {
                'bypassServiceArea': bypassServiceArea,
            },
        });
    }
    /**
     * @param appointmentId
     * @param preferredDate
     * @param preferredSecondaryDate
     * @param preferredTimeRange
     * @param addressLine1
     * @param addressLine2
     * @param city
     * @param state
     * @param zipCode
     * @param latitude
     * @param longitude
     * @param bookingFormId
     * @param preferredUserId
     * @param browseAllOpenSlots
     * @returns Routemize_DTOs_SchedulingResponse OK
     * @throws ApiError
     */
    public static getApiAppRoutemizationGetRescheduleSlots(
        appointmentId: string,
        preferredDate?: string,
        preferredSecondaryDate?: string,
        preferredTimeRange?: string,
        addressLine1?: string,
        addressLine2?: string,
        city?: string,
        state?: string,
        zipCode?: string,
        latitude?: number,
        longitude?: number,
        bookingFormId?: string,
        preferredUserId?: string,
        browseAllOpenSlots?: boolean,
    ): CancelablePromise<Routemize_DTOs_SchedulingResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/routemization/getRescheduleSlots',
            query: {
                'AppointmentId': appointmentId,
                'PreferredDate': preferredDate,
                'PreferredSecondaryDate': preferredSecondaryDate,
                'PreferredTimeRange': preferredTimeRange,
                'AddressLine1': addressLine1,
                'AddressLine2': addressLine2,
                'City': city,
                'State': state,
                'ZipCode': zipCode,
                'Latitude': latitude,
                'Longitude': longitude,
                'BookingFormId': bookingFormId,
                'PreferredUserId': preferredUserId,
                'BrowseAllOpenSlots': browseAllOpenSlots,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_HoldSlotResponse OK
     * @throws ApiError
     */
    public static postApiAppRoutemizationHoldSlot(
        requestBody?: Routemize_DTOs_HoldSlotRequest,
    ): CancelablePromise<Routemize_DTOs_HoldSlotResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/routemization/holdSlot',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_ReleaseSlotResponse OK
     * @throws ApiError
     */
    public static postApiAppRoutemizationReleaseSlot(
        requestBody?: Routemize_DTOs_ReleaseSlotRequest,
    ): CancelablePromise<Routemize_DTOs_ReleaseSlotResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/routemization/releaseSlot',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param slotId
     * @param sessionId
     * @returns Routemize_DTOs_SlotAvailabilityResponse OK
     * @throws ApiError
     */
    public static postApiAppRoutemizationCheckSlotAvailability(
        slotId?: string,
        sessionId?: string,
    ): CancelablePromise<Routemize_DTOs_SlotAvailabilityResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/routemization/checkSlotAvailability',
            query: {
                'slotId': slotId,
                'sessionId': sessionId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_ConfirmSlotResponse OK
     * @throws ApiError
     */
    public static postApiAppRoutemizationConfirmSlot(
        requestBody?: Routemize_DTOs_ConfirmSlotRequest,
    ): CancelablePromise<Routemize_DTOs_ConfirmSlotResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/routemization/confirmSlot',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
